import type { RouteRecordRaw } from 'vue-router';
import { AUTH_ROUTE_NAME } from '@/consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const resetPasswordRoutes: RouteRecordRaw = {
  path: '/auth/reset-password',
  component: () => import('@/layouts/public.vue'),
  meta: { i18n },
  children: [
    {
      path: '',
      name: AUTH_ROUTE_NAME.RESET_PASSWORD,
      component: () => import('./ResetPassword.vue'),
      meta: { onlyGuest: true },
    },
  ],
};
